/**
 * Created by nijin on 2/2/17.
 */
import {Component, OnInit, Input, ViewChild, ViewChildren, QueryList, OnChanges} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {LocAttrForm} from './loc-attribute-form.component';
import {GlobalService} from '../../global/global.service';

@Component({
    selector: 'nuc-edit-location',
    templateUrl: './edit-location.html',
    styleUrls: ['./edit-location.scss']
})
export class EditLocationComponent implements OnInit {
  @Input() location;
  @Input() dataTypes = [];
  @Input() isMobileApp = false;
  @Input() isPredefined = true;
  @ViewChild('attrForm') attrForm: LocAttrForm;
  @ViewChildren('fieldForm') fieldForm: QueryList<LocAttrForm>;
  isIn: Array<boolean> = [];

  locAttrForm: FormGroup;

  constructor(private globalService: GlobalService) {

    }

    ngOnInit() { }

  deleteLocAttribute(attribute) {
    let idx = this.location.indexOf(attribute);
    this.location.splice(idx, 1);
  }
  deleteLocAttrField(field, attr) {
    let idx = attr.fields.indexOf(field);
    attr.fields.splice(idx, 1);
  }

  addLocAttribute(data) {
    this.location.unshift(data.attribute);
  }

  isOpen(attribute, index) {
    if (attribute.datatype !== this.globalService.DATA_TYPE_JSON) {
      return this.isIn[index] = false;
    }
    if (!attribute.fields || !attribute.fields.length) {
      this.isIn[index] = true;
    }
    return this.isIn[index];
  }

  editAttributes(attribute, index) {
    this.attrForm.setFormValue(attribute, index);
  }

  updateLocAttribute(data) {
    if (this.location[data.index]) {
      this.location[data.index].name = data.attribute.name;
      this.location[data.index].datatype = data.attribute.datatype;
      this.location[data.index].required = data.attribute.required;
      this.location[data.index].precision = data.attribute.precision;
    }
    if (data.attribute.datatype !== this.globalService.DATA_TYPE_JSON) {
      this.location[data.index].fields = null;
    }
    this.isIn[data.index] = false;
  }

  editLocFields(attribute, formIndex, index) {
    this.fieldForm.toArray()[formIndex].setFormValue(attribute, index, formIndex);
  }
  updateLocFields(data) {
    if (this.location[data.attributeIndex].fields) {
      this.location[data.attributeIndex].fields[data.index].name = data.attribute.name;
      this.location[data.attributeIndex].fields[data.index].datatype = data.attribute.datatype;
      this.location[data.attributeIndex].fields[data.index].required = data.attribute.required;
      this.location[data.attributeIndex].fields[data.index].precision = data.attribute.precision;
    }
  }
  addLocFields(data) {
    if (!data.attribute) {
      return;
    }
    let idx = this.location.indexOf(data.attribute);
    this.location[idx].fields ? '' : this.location[idx].fields = [];
    this.location[idx].fields.unshift(data.field);
  }



}



// WEBPACK FOOTER //
// ./src/app/schema/edit-schema/edit-location.component.ts